import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import Layout from './Layout';
import './OrderDetails.css';

const OrderDetails = () => {
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const { orderId } = useParams();
  const navigate = useNavigate();

  const fetchOrderDetails = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(`https://gokulnair.com/new_project/api/order-details/${orderId}`);
      setOrder(response.data);
    } catch (err) {
      setError('Failed to fetch order details');
      console.error('Error fetching order details:', err);
    } finally {
      setLoading(false);
    }
  }, [orderId]);

  useEffect(() => {
    fetchOrderDetails();
  }, [fetchOrderDetails]);

  const getPaymentTypeText = (type) => {
    switch (type) {
      case 0: return 'Zelle';
      case 1: return 'Cash App';
      default: return 'Unknown';
    }
  };

  const getPaymentStatusText = (status) => {
    switch (status) {
      case 0: return 'Pending';
      case 1: return 'Confirmed by User';
      case 2: return 'Confirmed by Admin';
      case 3: return 'Rejected by Admin';
      case 4: return 'Rejected by User';
      default: return 'Unknown';
    }
  };

  const getPaymentStatusClass = (status) => {
    switch (status) {
      case 0: return 'status-pending';
      case 1: return 'status-confirmed-user';
      case 2: return 'status-confirmed-admin';
      case 3: return 'status-rejected-admin';
      case 4: return 'status-rejected-user';
      default: return 'status-pending';
    }
  };

  if (loading) {
    return (
      <Layout>
        <div className="loading">Loading order details...</div>
      </Layout>
    );
  }

  if (error) {
    return (
      <Layout>
        <div className="order-details-content">
          <div className="error-message">{error}</div>
          <button onClick={() => navigate('/dashboard')} className="back-button">
            Back to Dashboard
          </button>
        </div>
      </Layout>
    );
  }

  if (!order) {
    return (
      <Layout>
        <div className="order-details-content">
          <div className="no-order">Order not found</div>
          <button onClick={() => navigate('/dashboard')} className="back-button">
            Back to Dashboard
          </button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="order-details-content">
        <header className="order-details-header">
          <div className="header-left">
            <h1>Order Details</h1>
            <p>Order ID: {order.order_id}</p>
          </div>
          <button onClick={() => navigate('/dashboard')} className="back-button">
            Back to Dashboard
          </button>
        </header>

        <main className="order-details-main">
          <div className="order-card">
            <div className="order-section">
              <h2>Customer Information</h2>
              <div className="info-grid">
                <div className="info-item">
                  <label>Name:</label>
                  <span>{order.name}</span>
                </div>
                <div className="info-item">
                  <label>Email:</label>
                  <span>{order.email}</span>
                </div>
                <div className="info-item">
                  <label>Phone:</label>
                  <span>{order.phone}</span>
                </div>
              </div>
            </div>

            <div className="order-section">
              <h2>Shipping Address</h2>
              <div className="address-info">
                <p>{order.shipping_address}</p>
                <p>{order.shipping_city}, {order.shipping_state} {order.shipping_pincode}</p>
              </div>
            </div>

            <div className="order-section">
              <h2>Order Information</h2>
              <div className="info-grid">
                <div className="info-item">
                  <label>Order ID:</label>
                  <span>{order.order_id}</span>
                </div>
                              <div className="info-item">
                <label>Payment Type:</label>
                <span className="payment-type-badge">
                  {getPaymentTypeText(order.payment_type)}
                </span>
              </div>
              <div className="info-item">
                <label>Payment Status:</label>
                <span className={`status-badge ${getPaymentStatusClass(order.payment_status)}`}>
                  {getPaymentStatusText(order.payment_status)}
                </span>
              </div>
                <div className="info-item">
                  <label>Created Date:</label>
                  <span>{new Date(order.created_at).toLocaleString()}</span>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </Layout>
  );
};

export default OrderDetails; 